import { borders, borderRadii, IBorders, IBorderRadii } from './borders';
import { breakpoints, IBreakpoints } from './breakpoints';
import { colors, IColors } from './colors';
import { zIndex, IZIndex } from './zIndex';

export { fadeIn } from './animation';
export { colors } from './colors';
export { media } from './media';
export { variableFontRegular, variableFontMedium, variableFont } from './text';

export interface ITheme {
  borders: IBorders;
  borderRadii: IBorderRadii;
  breakpoints: IBreakpoints;
  colors: IColors;
  zIndex: IZIndex;
}

export const theme: ITheme = {
  borders,
  borderRadii,
  breakpoints,
  colors,
  zIndex,
};
